export enum MuiAvatarDisplayType {
  AVATAR = 'AVATAR',
  INITIALS = 'INITIALS',
  ICON = 'ICON'
}
